// $(window).on("load", function() {
//     setTimeout(() => {
//         $('img.main-cover').css('opacity', '0');
//     }, 1000);
// });

var rect = $('section.main-cover')[0].getBoundingClientRect();
var mouse = {x: 0, y: 0, moved: false};

$("section.main-cover").mousemove(function(e) {
    mouse.moved = true;
    mouse.x = e.clientX - rect.left;
    mouse.y = e.clientY - rect.top;
});
 
// Ticker event will be called on every frame
TweenLite.ticker.addEventListener('tick', function(){
    if (mouse.moved && $(window).width() > 768){    
        parallaxIt("h1", 5);
        parallaxIt(".jokowi", -5);
        parallaxIt(".menteri", 10);
        parallaxIt(".escavator", 20);
        parallaxIt(".megaphone", 25);
        parallaxIt(".wheat", -25);
    }
    mouse.moved = false;
});

function parallaxIt(target, movement) {
    TweenMax.to(target, 0.5, {
        x: (mouse.x - rect.width / 2) / rect.width * movement,
        y: (mouse.y - rect.height / 2) / rect.height * movement
    });
}

$(window).on('resize scroll', function(){
    rect = $('section.main-cover')[0].getBoundingClientRect();
});

// fullscreen height
$('.fp-section').each(function (i, e) {
    $(e).height($(window).height());
});

$(window).resize(function () { 
    $('.fp-section').each(function (i, e) {
        $(e).height($(window).height());
    });
});

